const ORDER_SERVICE_CODE = {
  OtherDay: 29,
  NarrowInterval: 36,
}

export default ORDER_SERVICE_CODE
